import { ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { LayoutContext } from "./context";
import { LayoutContextType } from "./type";
import { RIGHT_PANEL_MIN_WIDTH } from "../../components/layout/const";

const { Provider } = LayoutContext;

export const LayoutProvider = (props: { children: ReactNode }): JSX.Element => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    location.pathname.includes("_preview"),
  );
  const [rightPanelWidth, setRightPanelWidth] = useState(RIGHT_PANEL_MIN_WIDTH);
  const [isComparing, setIsComparing] = useState(false);

  useEffect(() => {
    if (location.pathname === "/chat" && isSidebarOpen) {
      setIsSidebarOpen(false);
    }
  }, [isSidebarOpen, location.pathname]);

  const value: LayoutContextType = {
    isSidebarOpen,
    setIsSidebarOpen,
    rightPanelWidth,
    setRightPanelWidth,
    isComparing,
    setIsComparing,
  };

  return <Provider value={value}>{props.children}</Provider>;
};
